@if (listData) {
  <div class="list-container">
    @for (instrumentCategory of parsedData; track instrumentCategory; let i = $index) {
      <div>
        @if (instrumentCategory.categoryName) {
          <div class="category-name" [ngStyle]="{ color: instrumentCategoryColors[instrumentCategory.categoryName] }" data-cy="instrument-dropdown-category-name">
            {{ 'investmentChartCategories.' + instrumentCategory.categoryName | translate }}
          </div>
        }
        @for (instrument of instrumentCategory.instrumentContent; track instrument.instrument.instrumentId) {
          <div class="list-item-container">
            <libero-dropdown-list-item
              [instrument]="instrument"
              [instrumentRatios]="instrument.instrument.cash ? parsedRatios[CASH_ID] : parsedRatios[instrument.instrument.instrumentId]"
            ></libero-dropdown-list-item>
          </div>
        }
        @if (i+1 !== parsedData.length) {
          <hr class="divider">
        }
      </div>
    }
  </div>
}